// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"089e2cbd","703":"4f57007c","787":"73b26258"}[chunkId] + ".chunk.js";
};